import { useI18n } from "vue-i18n";
import html_iway from "./template.iway.html?raw";
import ErrorMessage from "../../Shared/ErrorMessage";
import { computed, inject, ref } from "vue";
import { priceFormatterKey } from "../../../infrastructure/price_formatter";
import { currentOrderProviderKey } from "../../../infrastructure/current_order_provider";
import { orderApiKey } from "../../../infrastructure/gfo_api/order_api";
import OptionsBlockRow from "../OptionsBlockRow";
import OptionsShowMoreToggle from "../OptionsShowMoreToggle";
import type { AddToCartRequest, ProductVariantDto, RemoveFromCartRequest } from "../../../infrastructure/gfo_api/order_api";

const app_theme = import.meta.env.VITE_APP_THEME;
let html = "";
if ("iway" == app_theme) {
  html = html_iway;
} else if ("lic" == app_theme) {
  html = html_iway;
} else if ("sak" == app_theme) {
  html = html_iway;
}

export default {
  template: html,
  components: { ErrorMessage, OptionsBlockRow, OptionsShowMoreToggle },
  props: {
    className: {
      type: String,
      default: ""
    }
  },
  setup() {
    // imports
    const { t } = useI18n();
    const currentOrderProvider = inject(currentOrderProviderKey);
    const priceFormatter = inject(priceFormatterKey);
    const orderApi = inject(orderApiKey);

    // local vars
    const showMoreOpen = ref(false);

    // computed
    const productId = 25;
    const optionVariants = computed(() => {
      const variants = currentOrderProvider?.availableVariants?.value?.filter(
        (v) => v.product_id == productId  && v.qty_price_for == 0,
      );
      return variants ?? [];
    });
    const recommendation = computed(() => optionVariants.value[0] ?? null);
    const otherVariants = computed(() => {
      let variants = optionVariants.value;
      if (null != recommendation.value){
        variants = variants.filter(x => x.id != recommendation.value.id);
      }
      return variants;
    });
    const hasRecommendation = computed(() => recommendation.value != null);
    const hasMore = computed(() => hasRecommendation.value && otherVariants.value.length > 0);
    const vatType = computed(() => {
      return currentOrderProvider?.currentOrder?.value?.vat_type;
    });

    // Methods
    const toggleShowMore = () => showMoreOpen.value = !showMoreOpen.value;
    const handleAddQuantity = async(variant: ProductVariantDto, quantity: number) => {
      const order_reference = currentOrderProvider?.currentOrder?.value?.order_reference;
      if (!order_reference) return;
      if (quantity > 0){
        const request:AddToCartRequest = {
          product_variant_id: variant.id,
          reference: "",
          quantity: quantity
        }
        const resp = await orderApi?.addToCart(order_reference, request);
        if (resp){
          currentOrderProvider.set(resp.order);
          currentOrderProvider.setVariants(resp.available_variants);
        }

      } else {
        const request:RemoveFromCartRequest = {
          product_variant_id: variant.id,
          reference: "",
          quantity: (-1) * quantity
        }
        const resp = await orderApi?.removeFromCart(order_reference, request);
        if (resp){
          currentOrderProvider.set(resp.order);
          currentOrderProvider.setVariants(resp.available_variants);
        }
      }

    // hier machst du deine Logik
  };

    return {
      recommendation,
      productId,
      optionVariants,
      hasRecommendation,
      hasMore,
      handleAddQuantity,
      otherVariants,
      priceFormatter,
      showMoreOpen,
      toggleShowMore,
      t,
      vatType,
    };
  },
};
